// leaving this in incase we need a hook into again later
const getOtmmUrl = (requestPath) => `${requestPath}`;

export default getOtmmUrl;
